export default "<app-intro></app-intro>\n<app-footer></app-footer>\n"